import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from '@sfey/ui/notifications';
import { catchError, of, ReplaySubject, throwError } from 'rxjs';
import { HealthResponse } from './api.models';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class ErrorManagementService {
    private latestPaymentError$ = new ReplaySubject<HttpErrorResponse>(1);

    constructor(
        private apiService: ApiService,
        private notificationsService: NotificationsService,
        private translateService: TranslateService,
        private router: Router
    ) {}

    get latest$() {
        return this.latestPaymentError$;
    }

    handleError(request: HttpRequest<unknown>, response) {
        if (!(response instanceof HttpErrorResponse)) {
            throwError(() => response);
        }

        this.apiService
            .getHealth()
            .pipe(
                catchError(() => {
                    return of({ status: 'UNKNOWN' } as HealthResponse);
                })
            )
            .subscribe((health) => {
                if (health.status === 'UP') {
                    this.handleErrorWhenBackendUp(request, response);
                } else {
                    this.handleErrorWhenBackendDown();
                }
            });
    }

    private handleErrorWhenBackendUp(request: HttpRequest<unknown>, response: HttpErrorResponse) {
        console.error(response.error?.message, response.statusText);

        const unexpectedError = this.translateService.instant('notifications.unexpectedError');

        if (request.url.includes('/admin/')) {
            this.notificationsService.addError(response.error?.message ?? unexpectedError);
        } else {
            this.handlePaymentError(response);
        }

        throwError(() => response);
    }

    private handleErrorWhenBackendDown() {
        this.router.navigate(['/maintenance']);
    }

    private handlePaymentError(response: HttpErrorResponse) {
        this.latestPaymentError$.next(response);

        if (response.error.code === 'ALREADY_SETTLED') {
            window.location.reload(); // Reload to page so it would reach the "Order already paid" screen.
        }
    }
}
